import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '@services/toast.service';
import { IconComponent } from '../icons.component';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent {
  private toastService = inject(ToastService);
  
  toasts = this.toastService.getToasts();

  getIcon(type: string): string {
    switch (type) {
      case 'success': return 'circle-check';
      case 'error': return 'circle-x';
      case 'warning': return 'alert-triangle';
      case 'info': return 'info';
      default: return 'info';
    }
  }
}
